var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "asc__insertPage" },
    [
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "header",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "6" } },
                  [_c("Breadcrumb")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "text-right", attrs: { cols: "12", md: "6" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "LoyaltyCategory" } } },
                      [_c("CancelButton")],
                      1
                    ),
                    _vm._v(" "),
                    _c("AddButton", {
                      nativeOn: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "asc__insertPage-content-head", attrs: { cols: "12" } },
        [
          _c(
            "section",
            [
              _c(
                "b-row",
                [
                  _c(
                    "NextFormGroup",
                    { attrs: { "item-key": "Code", error: _vm.$v.form.Code } },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.Code
                        },
                        model: {
                          value: _vm.form.Code,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Code", $$v)
                          },
                          expression: "form.Code"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "Description1",
                        error: _vm.$v.form.Description1
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.Description1
                        },
                        model: {
                          value: _vm.form.Description1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Description1", $$v)
                          },
                          expression: "form.Description1"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "StatusId",
                        error: _vm.$v.form.StatusId
                      }
                    },
                    [
                      _c("NextCheckBox", {
                        attrs: { type: "number", toggle: "" },
                        model: {
                          value: _vm.form.StatusId,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "StatusId", $$v)
                          },
                          expression: "form.StatusId"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "MinValue",
                        error: _vm.$v.form.MinValue
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "number",
                          disabled: !(
                            _vm.CategoryType && _vm.CategoryType.Code == "ARA"
                          )
                        },
                        model: {
                          value: _vm.form.MinValue,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "MinValue", $$v)
                          },
                          expression: "form.MinValue"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "MaxValue",
                        error: _vm.$v.form.MaxValue
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "number",
                          disabled: !(
                            _vm.CategoryType && _vm.CategoryType.Code == "ARA"
                          )
                        },
                        model: {
                          value: _vm.form.MaxValue,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "MaxValue", $$v)
                          },
                          expression: "form.MaxValue"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "CategoryTypeId",
                        error: _vm.$v.form.CategoryTypeId
                      }
                    },
                    [
                      _c("NextDropdown", {
                        attrs: {
                          disabled: _vm.insertReadonly.CategoryTypeId,
                          options: _vm.types,
                          source: _vm.types
                            ? _vm.types.filter(function(c) {
                                return (
                                  c.Code == "DEG" ||
                                  c.Code == "ARA" ||
                                  c.Code == "OTO"
                                )
                              })
                            : [],
                          label: "Description1"
                        },
                        on: { input: _vm.selectCategoryType },
                        model: {
                          value: _vm.CategoryType,
                          callback: function($$v) {
                            _vm.CategoryType = $$v
                          },
                          expression: "CategoryType"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "CalcTypeId",
                        error: _vm.$v.form.CalcTypeId
                      }
                    },
                    [
                      _c("NextDropdown", {
                        attrs: {
                          disabled: !(
                            _vm.CategoryType && _vm.CategoryType.Code == "OTO"
                          ),
                          "lookup-key": "LOYALTY_CATEGORY_CALC_TYPE"
                        },
                        on: { input: _vm.selectCalcType },
                        model: {
                          value: _vm.CalcType,
                          callback: function($$v) {
                            _vm.CalcType = $$v
                          },
                          expression: "CalcType"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "LoyaltyPoint",
                        error: _vm.$v.form.LoyaltyPoint
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "number",
                          disabled: !(
                            _vm.CalcType && _vm.CalcType.Code !== "AKS"
                          )
                        },
                        model: {
                          value: _vm.form.LoyaltyPoint,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "LoyaltyPoint", $$v)
                          },
                          expression: "form.LoyaltyPoint"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "FieldAnalysisId",
                        error: _vm.$v.form.FieldAnalysisId
                      }
                    },
                    [
                      _c("NextDropdown", {
                        attrs: {
                          disabled: !(
                            _vm.CalcType && _vm.CalcType.Code == "ANS"
                          ),
                          url:
                            "VisionNextFieldAnalysis/api/FieldAnalysis/SearchWithValidDate "
                        },
                        on: {
                          input: function($event) {
                            return _vm.selectAnalysis($event)
                          }
                        },
                        model: {
                          value: _vm.FieldAnalysis,
                          callback: function($$v) {
                            _vm.FieldAnalysis = $$v
                          },
                          expression: "FieldAnalysis"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "ByFrequency",
                        error: _vm.$v.form.ByFrequency
                      }
                    },
                    [
                      _c("NextCheckBox", {
                        attrs: {
                          type: "number",
                          disabled:
                            !(_vm.CalcType && _vm.CalcType.Code == "SA") &&
                            !(_vm.CalcType && _vm.CalcType.Code == "ANS"),
                          toggle: ""
                        },
                        model: {
                          value: _vm.form.ByFrequency,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "ByFrequency", $$v)
                          },
                          expression: "form.ByFrequency"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-tabs",
            [
              _vm.CalcType && _vm.CalcType.Code === "SH"
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        title: _vm.$t("insert.loyaltyCategory.salesTarget")
                      }
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _vm.CalcType && _vm.CalcType.Code === "SH"
                            ? _c(
                                "NextFormGroup",
                                {
                                  attrs: {
                                    "item-key": "ColumnName",
                                    error: _vm.$v.form.ColumnName
                                  }
                                },
                                [
                                  _c("NextDropdown", {
                                    attrs: {
                                      disabled: _vm.insertReadonly.ColumnName,
                                      url:
                                        "VisionNextCommonApi/api/LookupValue/GetValuesBySysParams?v=2",
                                      "dynamic-request": {
                                        paramId: "ITEM_CRITERIA"
                                      },
                                      label: "Label"
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.selectColumnName($event)
                                      }
                                    },
                                    model: {
                                      value: _vm.form.ColumnNameDesc,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "ColumnNameDesc",
                                          $$v
                                        )
                                      },
                                      expression: "form.ColumnNameDesc"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.CalcType && _vm.CalcType.Code === "SH"
                            ? _c(
                                "NextFormGroup",
                                {
                                  attrs: {
                                    "item-key": "ColumnValue",
                                    error: _vm.$v.form.ColumnValue
                                  }
                                },
                                [
                                  _c("NextDropdown", {
                                    attrs: {
                                      disabled: !_vm.form.ColumnNameDesc,
                                      source: _vm.columnValues,
                                      label: "Label"
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.selectedType(
                                          "ColumnValue",
                                          $event
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.form.ColumnValueDesc,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "ColumnValueDesc",
                                          $$v
                                        )
                                      },
                                      expression: "form.ColumnValueDesc"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.CalcType && _vm.CalcType.Code === "SH"
                            ? _c(
                                "NextFormGroup",
                                {
                                  attrs: {
                                    "item-key": "UnitId",
                                    error: _vm.$v.form.UnitId
                                  }
                                },
                                [
                                  _c("NextDropdown", {
                                    attrs: {
                                      disabled: _vm.insertReadonly.UnitId,
                                      "lookup-key": "UNIT"
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.selectedType(
                                          "UnitId",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.CalcType && _vm.CalcType.Code === "SH"
                            ? _c(
                                "NextFormGroup",
                                {
                                  attrs: {
                                    "item-key": "Quantity",
                                    error: _vm.$v.form.Quantity
                                  }
                                },
                                [
                                  _c("NextInput", {
                                    attrs: {
                                      type: "number",
                                      disabled: _vm.insertReadonly.Quantity
                                    },
                                    model: {
                                      value: _vm.form.Quantity,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "Quantity", $$v)
                                      },
                                      expression: "form.Quantity"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.CalcType && _vm.CalcType.Code === "SH"
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        lazy: "",
                        title: _vm.$t("insert.loyaltyCategory.salesTargetQuota")
                      }
                    },
                    [
                      _c("NextDetailPanel", {
                        attrs: {
                          items: _vm.loyaltyCatQuotasItems,
                          "before-add": _vm.beforeAddLoyaltyCatQuota
                        },
                        model: {
                          value: _vm.form.LoyaltyCatQuotas,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "LoyaltyCatQuotas", $$v)
                          },
                          expression: "form.LoyaltyCatQuotas"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.CalcType &&
              _vm.CalcType.Code === "ANS" &&
              _vm.FieldAnalysis &&
              _vm.FieldAnalysis.Code !== ""
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        lazy: "",
                        title: _vm.$t("insert.loyaltyCategory.analysisResult")
                      },
                      on: { click: _vm.setDatePlanType }
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "NextFormGroup",
                            {
                              attrs: {
                                title: _vm.$t(
                                  "insert.loyaltyCategory.description"
                                ),
                                error: _vm.$v.loyaltyCategory.description,
                                required: true
                              }
                            },
                            [
                              _c("NextInput", {
                                attrs: { type: "text" },
                                model: {
                                  value: _vm.loyaltyCategory.description,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.loyaltyCategory,
                                      "description",
                                      $$v
                                    )
                                  },
                                  expression: "loyaltyCategory.description"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "text-right",
                              attrs: { cols: "12", md: "2" }
                            },
                            [
                              _c(
                                "b-form-group",
                                [
                                  _c("AddDetailButton", {
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.addLoyaltyCategory(
                                          "LoyaltyCategoryCrits"
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-table", {
                            attrs: {
                              fields: _vm.loyaltyCategoryFields,
                              items: this.form.LoyaltyCategoryCrits
                                ? this.form.LoyaltyCategoryCrits.filter(
                                    function(i) {
                                      return i.RecordState !== 4
                                    }
                                  )
                                : [],
                              bordered: "",
                              responsive: ""
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "head()",
                                  fn: function(data) {
                                    return [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.$t(data.label)) +
                                          "\n            "
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "cell(operations)",
                                  fn: function(row) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "text-center" },
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              staticClass: "mr-2",
                                              attrs: {
                                                size: "sm",
                                                variant: "danger"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.removeLoyaltyCategory(
                                                    row.item,
                                                    "LoyaltyCategoryCrits"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "far fa-trash-alt"
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "insert.loyaltyCategory.delete"
                                                    )
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-button",
                                            {
                                              staticClass: "mr-2",
                                              attrs: {
                                                size: "sm",
                                                variant: "success"
                                              },
                                              on: { click: row.toggleDetails }
                                            },
                                            [
                                              _c("i", {
                                                class: row.detailsShowing
                                                  ? "fa fa-arrow-up"
                                                  : "fa fa-arrow-down"
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "insert.loyaltyCategory.details"
                                                    )
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "row-details",
                                  fn: function(ref) {
                                    var index = ref.index
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "p-4 mt-2 nested-detail-panel"
                                        },
                                        [
                                          _c("h3", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.loyaltyCategory.analysisResult"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            [
                                              _c(
                                                "NextFormGroup",
                                                {
                                                  attrs: {
                                                    title: _vm.$t(
                                                      "insert.loyaltyCategory.QuestionId"
                                                    ),
                                                    error:
                                                      _vm.$v.loyaltyQuestion
                                                        .question,
                                                    required: true
                                                  }
                                                },
                                                [
                                                  _c("NextDropdown", {
                                                    attrs: {
                                                      label: "Description1",
                                                      source: _vm.questions
                                                    },
                                                    on: {
                                                      input: _vm.selectQuestion
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.loyaltyQuestion
                                                          .question,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.loyaltyQuestion,
                                                          "question",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "loyaltyQuestion.question"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _vm.loyaltyQuestion.question &&
                                              _vm.loyaltyQuestion.question
                                                .AnswerType.Code === "CS"
                                                ? _c(
                                                    "NextFormGroup",
                                                    {
                                                      attrs: {
                                                        title: _vm.$t(
                                                          "insert.loyaltyCategory.Answer"
                                                        ),
                                                        error:
                                                          _vm.$v.loyaltyQuestion
                                                            .multipleAnswer,
                                                        required:
                                                          _vm.loyaltyQuestion
                                                            .question &&
                                                          _vm.loyaltyQuestion
                                                            .question.AnswerType
                                                            .Code === "CS"
                                                      }
                                                    },
                                                    [
                                                      _c("NextDropdown", {
                                                        attrs: {
                                                          source: _vm.answers,
                                                          label: "Description1"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.loyaltyQuestion
                                                              .multipleAnswer,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.loyaltyQuestion,
                                                              "multipleAnswer",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "loyaltyQuestion.multipleAnswer"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "NextFormGroup",
                                                {
                                                  attrs: {
                                                    title: _vm.$t(
                                                      "insert.loyaltyCategory.AnswerStart"
                                                    ),
                                                    error:
                                                      _vm.$v.loyaltyQuestion
                                                        .AnswerStart,
                                                    required: true
                                                  }
                                                },
                                                [
                                                  _c("NextInput", {
                                                    attrs: {
                                                      type: "number",
                                                      disabled:
                                                        _vm.loyaltyQuestion
                                                          .question &&
                                                        _vm.loyaltyQuestion
                                                          .question.AnswerType
                                                          .Code !== "SY"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.loyaltyQuestion
                                                          .AnswerStart,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.loyaltyQuestion,
                                                          "AnswerStart",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "loyaltyQuestion.AnswerStart"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "NextFormGroup",
                                                {
                                                  attrs: {
                                                    title: _vm.$t(
                                                      "insert.loyaltyCategory.AnswerEnd"
                                                    ),
                                                    error:
                                                      _vm.$v.loyaltyQuestion
                                                        .AnswerEnd,
                                                    required: true
                                                  }
                                                },
                                                [
                                                  _c("NextInput", {
                                                    attrs: {
                                                      type: "number",
                                                      disabled:
                                                        _vm.loyaltyQuestion
                                                          .question &&
                                                        _vm.loyaltyQuestion
                                                          .question.AnswerType
                                                          .Code !== "SY"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.loyaltyQuestion
                                                          .AnswerEnd,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.loyaltyQuestion,
                                                          "AnswerEnd",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "loyaltyQuestion.AnswerEnd"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass: "text-right",
                                                  attrs: { cols: "12", md: "2" }
                                                },
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    [
                                                      _c("AddDetailButton", {
                                                        nativeOn: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.addLoyaltyQuestion(
                                                              index
                                                            )
                                                          }
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            [
                                              _c("b-table", {
                                                attrs: {
                                                  items:
                                                    _vm.form
                                                      .LoyaltyCategoryCrits[
                                                      index
                                                    ]
                                                      .LoyaltyCategoryCritDetails,
                                                  fields:
                                                    _vm.loyaltyQuestionFields
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "head()",
                                                      fn: function(data) {
                                                        return [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  data.label
                                                                )
                                                              ) +
                                                              "\n                    "
                                                          )
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      key: "cell(operations)",
                                                      fn: function(row) {
                                                        return [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "text-center"
                                                            },
                                                            [
                                                              _c(
                                                                "b-button",
                                                                {
                                                                  staticClass:
                                                                    "mr-2",
                                                                  attrs: {
                                                                    size: "sm",
                                                                    variant:
                                                                      "danger"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.removeLoyaltyQuestion(
                                                                        row.item,
                                                                        index
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "far fa-trash-alt"
                                                                  }),
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "insert.loyaltyCategory.delete"
                                                                        )
                                                                      ) +
                                                                      "\n                        "
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1201460302
                            )
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.CategoryType && _vm.CategoryType.Code === "DEG"
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        lazy: "",
                        title: _vm.$t("insert.loyaltyCategory.questionChoice")
                      }
                    },
                    [
                      _c("NextDetailPanel", {
                        attrs: { items: _vm.loyaltyCategoryValuesItems },
                        model: {
                          value: _vm.form.LoyaltyCategoryValues,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "LoyaltyCategoryValues", $$v)
                          },
                          expression: "form.LoyaltyCategoryValues"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.CalcType && _vm.CalcType.Code === "AKS"
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        lazy: "",
                        title: _vm.$t("insert.loyaltyCategory.activityResult")
                      }
                    },
                    [
                      _c("NextDetailPanel", {
                        attrs: { items: _vm.loyaltyCategoryTasksItems },
                        model: {
                          value: _vm.form.LoyaltyCategoryTasks,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "LoyaltyCategoryTasks", $$v)
                          },
                          expression: "form.LoyaltyCategoryTasks"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.CalcType && _vm.CalcType.Code === "SA"
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        lazy: "",
                        title: _vm.$t("insert.loyaltyCategory.salesAnalysis")
                      }
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "NextFormGroup",
                            {
                              attrs: {
                                title: _vm.$t(
                                  "insert.loyaltyCategory.description"
                                ),
                                error: _vm.$v.loyaltyCategory.description,
                                required: true
                              }
                            },
                            [
                              _c("NextInput", {
                                attrs: { type: "text" },
                                model: {
                                  value: _vm.loyaltyCategory.description,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.loyaltyCategory,
                                      "description",
                                      $$v
                                    )
                                  },
                                  expression: "loyaltyCategory.description"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "text-right",
                              attrs: { cols: "12", md: "2" }
                            },
                            [
                              _c(
                                "b-form-group",
                                [
                                  _c("AddDetailButton", {
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.addLoyaltyCategory(
                                          "LoyaltyCatSales"
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-table", {
                            attrs: {
                              fields: _vm.loyaltyCategoryFields,
                              items: this.form.LoyaltyCatSales
                                ? this.form.LoyaltyCatSales.filter(function(i) {
                                    return i.RecordState !== 4
                                  })
                                : [],
                              bordered: "",
                              responsive: ""
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "head()",
                                  fn: function(data) {
                                    return [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.$t(data.label)) +
                                          "\n            "
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "cell(operations)",
                                  fn: function(row) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "text-center" },
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              staticClass: "mr-2",
                                              attrs: {
                                                size: "sm",
                                                variant: "danger"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.removeLoyaltyCategory(
                                                    row.item,
                                                    "LoyaltyCatSales"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "far fa-trash-alt"
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "insert.loyaltyCategory.delete"
                                                    )
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-button",
                                            {
                                              staticClass: "mr-2",
                                              attrs: {
                                                size: "sm",
                                                variant: "success"
                                              },
                                              on: { click: row.toggleDetails }
                                            },
                                            [
                                              _c("i", {
                                                class: row.detailsShowing
                                                  ? "fa fa-arrow-up"
                                                  : "fa fa-arrow-down"
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "insert.loyaltyCategory.details"
                                                    )
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "row-details",
                                  fn: function(ref) {
                                    var index = ref.index
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "p-4 mt-2 nested-detail-panel"
                                        },
                                        [
                                          _c("h3", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.loyaltyCategory.salesAnalysis"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("NextDetailPanel", {
                                            attrs: {
                                              items:
                                                _vm.LoyaltyCatSalesDetailsItems
                                            },
                                            model: {
                                              value:
                                                _vm.form.LoyaltyCatSales[index]
                                                  .LoyaltyCatSalesDetails,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form.LoyaltyCatSales[
                                                    index
                                                  ],
                                                  "LoyaltyCatSalesDetails",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.LoyaltyCatSales[index].LoyaltyCatSalesDetails"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              4059060356
                            )
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f869d68", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f869d68","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/LoyaltyCategory/insert.vue
// module id = null
// module chunks = 